<script>
    import {authService, isAuth} from "../services/auth.service";

    async function login() {
        await authService.login();
    }

    async function logout() {
        await authService.logout();
    }
</script>

{#if $isAuth }
<button on:click="{logout}">Log out</button>
{:else}
<button on:click="{login}">Log in</button>
{/if}